import type { FaireProductEntity } from "../../entity_types/product";

export const p_evqmv73f77: FaireProductEntity = {
  token: "p_evqmv73f77",
  type: "product",
  name: "THE MINIS : HAWAII DREAM STICKER PACK",
  brandName: "Lauren Taylor Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/87c94a4842f46d8510f570246cfa6cc3c56a1342e898cb9c8e22d0cb19e935c4.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6148f33a73a91c196d9c28fa97987f81b4d40356b0b37e9d12c54f7f092845a5.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
